export const systemNotifications: JSX.Element[] = [];
